export function checkIfInIframe() {
	if (window.top !== window.self) {
		// Page is in an iframe
		return true;
	} else {
		// Page is not in an iframe
		return false;
	}
}
